import React, { useState, useEffect } from 'react';
import {
  Card,
  Col,
  Row,
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SyntaxEditor from './SyntaxEditor';
import { updateTrackers } from "../../../actions/settings";
import DeleteConfirmForm from "../../../components/settings/DeleteConfirmForm";
import _ from "lodash";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import './Trackers.scss';

const ReactSwal = withReactContent(Swal);

const Trackers = props => {
  const [scripts, setScripts] = useState({
    header: '',
    footer: ''
  })

  useEffect(() => {
    const scriptsValue = _.get(props.settings, `trackers`, null)

    if (scriptsValue) {
      setScripts({
        header: scriptsValue.header || '',
        footer: scriptsValue.footer || '',
      })
    }
  }, [])

  const onChangeScript = (type, value) => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <DeleteConfirmForm
          type='updateTracer'
          data={type}
          onClose={ReactSwal.clickCancel}
          onConfirm={ReactSwal.clickConfirm}
        />
      )
    })
    .then(result => {
      if (result.value) {
        props.updateTrackers({
          [type]: value
        })
    
        // setScripts({
        //   ...scripts,
        //   [type]: value
        // })
      }
    });
  }

  return (
    <div className="trackers-container">
      <Row className="full-width">
        <Col>
          <Row className="full-width">
            <Card bg="light" className="full-width full-height">
              <Card.Header>About Trackers</Card.Header>
              <Card.Body>
                <p>This section allows you to add HTML or Javascript to the header or footer of the published collection pages, also known as "sites".</p> 
                <p>By adding HTML and Javascript you can enable additional 3rd party trackers like Google Tag Manager, Google Analytics, Hubspot and even add interactive features like chat directly to your pages <span role="img" aria-label="raise hand">🙌</span></p>
              </Card.Body>
            </Card>
          </Row>
          <Row className="full-width">
            <Card bg="light" className="full-width full-height">
              <Card.Header>Header</Card.Header>
              <Card.Body>
                <p>Add HTML and JavaScript snippets to the header of published collection site pages</p>
                <SyntaxEditor value={scripts.header} onChange={value => onChangeScript('header', value)} />
              </Card.Body>
            </Card>
          </Row>

          <Row className="full-width">
            <Card bg="light" className="full-width full-height">
              <Card.Header>Footer</Card.Header>
              <Card.Body>
                <p>Add HTML and JavaScript snippets to the footer of published collection site pages</p>
                <SyntaxEditor value={scripts.footer} onChange={value => onChangeScript('footer', value)} />
              </Card.Body>
            </Card>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

const mapStateToProps = state => ({
  settings: state.settings,
});

const mapDispatchToProps = dispatch => 
bindActionCreators({
  updateTrackers,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Trackers);
